import { Result } from "antd";
import strings from "localisation/strings";
import React from "react";

export default () => (
  <Result status="403" title="403" subTitle={strings("errors.notAuthorized")} />
);
